(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;

// const isConfirmNewsletter = !isLargeScreen &&
// (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen; // ||  isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
    
    customElements.define('nav-menu', NavMenu);
  });
  document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
            let h1ElementStoreTitle = document.getElementById('SmartCart_title');
            if (h1ElementStoreTitle) {
                let spanContentNode = document.createElement('span');
                spanContentNode.innerHTML = h1ElementStoreTitle.innerHTML;
                spanContentNode.id = h1ElementStoreTitle.id;
                h1ElementStoreTitle.parentNode.replaceChild(spanContentNode, h1ElementStoreTitle);
                let parentTitleElementDiv = spanContentNode.parentNode;
                parentTitleElementDiv.classList.add('custom-cart-title');
            } else {
                console.log('Element Not Found');
            }

            let titleRebuyWidget = document.querySelector('.primary-title');
            if (titleRebuyWidget) {
            let spanContentTitle = document.createElement('span');
              spanContentTitle.innerHTML = titleRebuyWidget.innerHTML; 
              spanContentTitle.className = titleRebuyWidget.className;
              spanContentTitle.style.cssText = titleRebuyWidget.style.cssText;
              spanContentTitle.style.fontSize = "18px";
              spanContentTitle.style.fontWeight = "bold";
              titleRebuyWidget.parentNode.replaceChild(spanContentTitle, titleRebuyWidget);
            } else {
            console.log('Element Not Found');
            }
            let emptyCartPlugin = document.querySelector('.rebuy-cart__flyout-empty-cart');
              if(emptyCartPlugin){
                let h4EmptyCartPlugin = emptyCartPlugin.querySelector('h4');
                if(h4EmptyCartPlugin){
                  let spanContentEmpty = document.createElement('span');
                  spanContentEmpty.innerHTML = h4EmptyCartPlugin.innerHTML; 
                  spanContentEmpty.className = h4EmptyCartPlugin.className;
                  spanContentEmpty.style.cssText = h4EmptyCartPlugin.style.cssText;
                  h4EmptyCartPlugin.parentNode.replaceChild(spanContentEmpty, h4EmptyCartPlugin);
                  spanContentEmpty.classList.add('rebuy-cart-plugin__empty_cart');
                }
              }
            
      }, 5000); 
  })


  } catch(e) { console.error(e); }
})();
})();
